import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20background%20with%20soft%20flowing%20organic%20shapes%20in%20amber%20and%20cream%20tones%2C%20gentle%20gradients%2C%20minimalist%20elegant%20composition%2C%20calm%20sophisticated%20atmosphere%2C%20editorial%20style%2C%20harmonious%20balanced%20design&width=1800&height=800&seq=cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/45"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-semibold text-white">
          准备好拓展你的社交圈了吗？
        </h2>
        <p className="mt-4 text-sm md:text-base text-white/75 max-w-lg mx-auto leading-relaxed">
          从姐姐的朋友圈开始，打开你人生中最重要的社交入口。每一个真诚的连接，都可能带来意想不到的机遇。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/jiejie-pengyouquan"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm transition-all whitespace-nowrap cursor-pointer"
          >
            立即开始学习
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full text-sm transition-all backdrop-blur-sm whitespace-nowrap cursor-pointer"
          >
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}